import React, { useRef, createRef, useEffect } from 'react';
import SEO from '../../components/SEO';
import Layout from '../../components/Layout';
import Container from '../../components/Container';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import { FormattedHTMLMessage, useIntl } from 'gatsby-plugin-intl';
import InstitutionsBanner from '../../components/InstitutionsBanner';
import InstitutionsSolutions from '../../components/InstitutionsSolutions';
import Button from '../../components/Button';
import Client from '../../components/Client';
import InstitutionsForm from '../../components/InstitutionsForm';
import { useAppContext } from '../../context/AppContext';
import { useLocation, useMount } from 'react-use';

const CustomButton = () => {
  const { institutionsFormRef } = useAppContext();
  return (
    <Button scrollToRef={institutionsFormRef}>
      <FormattedHTMLMessage id={`institutions.request`} />
    </Button>
  );
};

const Circle = ({ top = [0, 0, 0], x = [0, 0, 0], right = false }) => {
  return (
    <div
      css={css`
        position: absolute;
        top: ${top[0]}px;
        left: ${right ? 'auto' : '0%'};
        right: ${right ? '0%' : 'auto'};
        background: #ededee;
        opacity: 0.5;
        z-index: -2;
        width: 408px;
        height: 408px;
        border-radius: 408px;
        transform: ${`translateX(${x[0]}px)`};
        ${Tablet} {
          left: 50%;
          right: auto;
          top: ${top[1]}px;
          width: 736px;
          height: 736px;
          border-radius: 736px;
          transform: ${`translateX(${x[1]}px)`};
        }
        ${Desktop} {
          top: ${top[2]}px;
          width: 1148px;
          height: 1148px;
          border-radius: 1148px;
          transform: ${`translateX(${x[2]}px)`};
        }
      `}
    ></div>
  );
};

const InstitutionsPage = () => {
  const intl = useIntl();
  const advisoryRef = useRef();
  const selectionRef = useRef();
  const smartfundRef = useRef();
  const refMap = {
    advisory: advisoryRef,
    selection: selectionRef,
    smartfund: smartfundRef,
  };
  const location = useLocation();
  // useMount(() => {
  //   if (/advisory/i.test(window.location.search)) {
  //     console.log('advisory');
  //   }
  //   console.log(11111111);
  //   window.scrollTo({
  //     top: advisoryRef.current.offsetTop,
  //     behavior: 'smooth',
  //   });
  // });
  useEffect(() => {
    let currentRef = refMap[window.location.search.slice(1)];
    if (currentRef) {
      // console.log(
      //   'location.search change****************',
      //   currentRef.current.offsetTop
      // );
      setTimeout(() => {
        window.scrollTo({
          top: currentRef.current.offsetTop,
          behavior: 'smooth',
        });
      }, 0);
    }
  }, [location.search]);

  return (
    <Layout footerBand={false}>
      <SEO
        title={intl.formatMessage({ id: 'institutions.title' })}
        description={intl.formatMessage({ id: 'institutions.description' })}
        keywords={intl.formatMessage({ id: 'institutions.keywords' })}
      />
      <InstitutionsBanner>
        <FormattedHTMLMessage id='institutions.title' />
      </InstitutionsBanner>
      <Container
        css={css`
          display: flex;
          flex-direction: column;
          margin-top: 80px;
          text-align: left;
          ${Tablet} {
            text-align: center;
          }
          ${Desktop} {
            margin-top: 150px;
          }
        `}
      >
        <h1
          css={css`
            ${Desktop} {
              padding: 0px 200px;
            }
          `}
        >
          <FormattedHTMLMessage id='institutions.platform.title' />
        </h1>
        <h3
          css={css`
            ${Tablet} {
              font-size: 16px;
              line-height: 25px;
            }
            ${Desktop} {
              font-size: 25px;
              line-height: 35px;
            }
          `}
        >
          <FormattedHTMLMessage id='institutions.platform.text' />
        </h3>
      </Container>
      {['advisory', 'selection', 'smartfund'].map((section, index) => {
        return (
          <Container
            key={section}
            css={css`
              margin-top: 100px;
              ${Desktop} {
                margin-top: 200px;
              }
            `}
          >
            <div
              ref={refMap[section]}
              css={css`
                width: 100%;
                display: flex;
                flex-direction: column;
                ${Tablet} {
                  flex-direction: ${index % 2 === 1 ? 'row-reverse' : 'row'};
                }
              `}
            >
              <div
                css={css`
                  align-items: flex-start;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  ${Tablet} {
                    flex: 0 0 55%;
                  }
                  ${Desktop} {
                    flex: 0 0 55%;
                  }
                `}
              >
                <h2
                  css={css`
                    margin-bottom: 20px;
                    ${Tablet} {
                      margin-bottom: 50px;
                    }
                  `}
                >
                  <FormattedHTMLMessage id={`institutions.${section}.title`} />
                </h2>
                <h3
                  css={css`
                    ${Tablet} {
                      font-size: 16px;
                      line-height: 25px;
                    }
                    ${Desktop} {
                      font-size: 25px;
                      line-height: 35px;
                    }
                  `}
                >
                  <FormattedHTMLMessage id={`institutions.${section}.text`} />
                </h3>
                <h3
                  css={css`
                    ${Tablet} {
                      font-size: 16px;
                      line-height: 25px;
                    }
                    ${Desktop} {
                      font-size: 25px;
                      line-height: 35px;
                    }
                  `}
                >
                  <ul
                    css={css`
                      li {
                        margin-bottom: 0px;
                      }
                    `}
                  >
                    {{
                      advisory: [1, 2],
                      selection: [1, 2],
                      smartfund: [1, 2, 3],
                    }[section].map((i) => {
                      return (
                        <li key={i}>
                          <FormattedHTMLMessage
                            id={`institutions.${section}.point-${i}`}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </h3>
              </div>
              <div
                css={css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  max-width: 400px;
                  ${Tablet} {
                    max-width: none;
                    flex: 0 0 45%;
                  }
                  ${Desktop} {
                    flex: 0 0 45%;
                  }
                `}
              >
                <div
                  css={
                    {
                      advisory: css`
                        width: 169px;
                        ${Tablet} {
                          width: 244px;
                        }
                        ${Desktop} {
                          width: 288px;
                        }
                        position: relative;
                      `,
                      selection: css`
                        width: 156px;
                        ${Tablet} {
                          width: 226px;
                        }
                        ${Desktop} {
                          width: 265px;
                        }
                        position: relative;
                      `,
                      smartfund: css`
                        width: 334px;
                        ${Tablet} {
                          width: 450px;
                        }
                        ${Desktop} {
                          width: 510px;
                        }
                        position: relative;
                      `,
                    }[section]
                  }
                >
                  <img
                    css={css`
                      width: 100%;
                    `}
                    src={`/institutions/video/${section}-frame.png`}
                    alt=''
                  />
                  <video
                    css={
                      {
                        advisory: css`
                          position: absolute;
                          top: 3%;
                          left: 6%;
                          z-index: -1;
                          border-radius: 30px;
                          width: 84%;
                        `,
                        selection: css`
                          position: absolute;
                          top: 7%;
                          left: 6%;
                          z-index: -1;
                          width: 88%;
                        `,
                        smartfund: css`
                          position: absolute;
                          top: 10.5%;
                          left: 7%;
                          z-index: -1;
                          border-radius: 10px;
                          width: 84%;
                        `,
                      }[section]
                    }
                    src={`/institutions/video/${section}-${intl.locale}.mp4`}
                    autoPlay
                    muted
                    loop
                  />
                </div>
              </div>
            </div>
          </Container>
        );
      })}
      <Container
        css={css`
          text-align: left;
          margin-top: 100px;
          ${Tablet} {
            text-align: center;
          }
          ${Desktop} {
            margin-top: 200px;
          }
        `}
      >
        <h2>
          <FormattedHTMLMessage id={`institutions.solutions.title`} />
        </h2>
        <h3
          css={css`
            ${Tablet} {
              font-size: 16px;
              line-height: 25px;
            }
            ${Desktop} {
              font-size: 25px;
              line-height: 35px;
            }
          `}
        >
          <FormattedHTMLMessage id={`institutions.solutions.text`} />
        </h3>
      </Container>
      <InstitutionsSolutions />
      <Container>
        <div
          css={css`
            width: 100%;
            display: flex;
            justify-content: center;
          `}
        >
          <CustomButton />
        </div>
      </Container>
      <Container
        css={css`
          display: flex;
          flex-direction: column;
          margin-top: 100px;
          text-align: left;
          ${Tablet} {
            text-align: center;
            align-items: center;
          }
          ${Desktop} {
            margin-top: 150px;
            align-items: center;
          }
        `}
      >
        <h1
          css={css`
            ${Desktop} {
              padding: 0px 200px;
            }
          `}
        >
          <FormattedHTMLMessage id='institutions.clients.title' />
        </h1>
        <h3
          css={css`
            ${Tablet} {
              font-size: 16px;
              line-height: 25px;
              padding: 0 80px;
            }
            ${Desktop} {
              font-size: 25px;
              line-height: 35px;
              padding: 0 120px;
            }
          `}
        >
          <FormattedHTMLMessage id='institutions.clients.text' />
        </h3>
        <div
          css={css`
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            margin: 10px 0px;
            flex-wrap: wrap;
            ${Tablet} {
              justify-content: space-between;
              margin-left: -25px;
              margin-right: -25px;
              width: 750px;
            }
            ${Desktop} {
              justify-content: space-between;
              margin-left: -30px;
              margin-right: -30px;
              // width: 1220px;
              width: 1250px;
            }
          `}
        >
          {/* <Client width={[120, 110, 140]} name="aia" />
          <Client width={[120, 110, 180]} name="boci" />
          <Client width={[120, 200, 280]} name="bochk" />
          <Client width={[120, 140, 200]} name="cmb" />
          <Client width={[120, 140, 190]} name="china-amc" /> */}
          <Client width={[119, 83, 140]} name='aia.png' />
          <Client width={[160, 112, 180]} name='boci.png' />
          <Client width={[140, 109, 191]} name='bochk.png' />
          <Client width={[157, 98, 172]} name='cmb.png' />
          <Client width={[100, 109, 190]} name='china-amc.png' />
          <hr
            css={css`
              display: none;
              ${Tablet} {
                display: block;
              }
              height: 30px;
            `}
          />

          {/* <Client width={[120, 130, 190]} name="guangzhou" />
          <Client width={[120, 120, 140]} name="hua" />
          <Client width={[120, 100, 180]} name="zhuhai" />
          <Client width={[35, 35, 50]} name="ifast" />
          <Client width={[120, 140, 190]} name="china-amc" /> */}
          <Client width={[130, 104, 182]} name='guangzhou.png' />
          {/* 110px */}
          <Client width={[110, 84, 147]} name='hua.png' />
          <Client
            width={[150, 109, 190]}
            name={intl.formatMessage({
              id: `institutions.client-logo.ICBC`,
            })}
          />
          {/* <Client
            width={[150, 109, 190]}
            name="ICBC-cn.png"
          /> */}
          <Client width={[47, 35, 57]} name='ifast.png' />
          <Client width={[133, 105, 184]} name='zhuhai.png' />
        </div>
      </Container>
      <InstitutionsForm />
      <Circle top={[420, 0, 400]} x={[-220, -800, -1230]} />
      <Circle top={[1100, 700, 850]} x={[220, 0, 50]} right />
      <Circle top={[1700, 1400, 1850]} x={[-220, -700, -1230]} />
      <Circle top={[2500, 2000, 2800]} x={[220, 0, -50]} right />
    </Layout>
  );
};

export default InstitutionsPage;
